import "./index.css";
import React from "react";
import { render } from "react-dom";
import { App } from "./App";
render(<App data-id="element-5819" data-mp="1wal2ajeithp2" />, document.getElementById("root"));